import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';

export const FORM_FIELDS = {
  LOCATION: {
    name: 'url',
    label: 'URL',
    placeholder: 'Enter the YouTube URL...',
    rules: [
      { required: true, message: 'Url is required' },
      { type: 'url', message: "Doesn't look like a valid URL" },
    ],
  },
  TITLE: {
    name: 'title',
    label: 'Title',
    placeholder: 'Write a title for the feature video...',
    rules: [{ required: true, message: 'Title is required' }],
  },
  IMAGE: {
    name: 'previewImage',
    label: 'Preview image:',
    rules: [{ required: true, message: 'An image is required' }],
    size: IMAGE_SIZE['700x567'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
};

export const VIDEOS = {
  name: 'slides',
  label: 'Current videos',
  rules: [{ min: 1, max: 20 }],
};
